import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import classNames from "classnames";
import { fetchPointsHistory, useDispatch, useSelector } from "@jti/store";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";
import { Button, DEPRECATED_Typography as Typography, Loading, LoadMore, useConfig, useTranslations } from "@jti/ui";
import redirectToAuthPage from "../../helpers/functions/redirectToAuthPage";
import useLoggedUser from "../../helpers/hooks/useLoggedUser";
import { ConditionalView } from "../conditional-view/ConditionalView";
import { HistoryTable } from "../history-table/HistoryTable";
import ScrollToTop from "../scroll-to-top/ScrollToTop";
import { historyItemsAuthoring } from "./__data__/historyItemsAuthoring";
import styles from "./PointsHistory.module.scss";
export const PointsHistory = ({ isFullPointsHistory, loadAmount = 5, text, title = "Points history", defaultPointsAddedMessage, defaultPointsSpentMessage, pointsRefundMessage = "Points refunded", pointsOrderAddedMessage, pointsRedemptionMessage, pointsCouponRedemptionMessage, pointsCancellationMessage, pointsExpirationMessage, externalCouponLinkLabel, balanceLabel, eventLabel, pointsLabel, dateLabel, url, isInEditor, removeMargin, }) => {
    const config = useConfig();
    const dispatch = useDispatch();
    const [isLogged] = useLoggedUser();
    const [pageNo, setPageNo] = useState(1);
    const { __ } = useTranslations();
    const { historyPoints: storeHistoryPoints } = useSelector((state) => state.loyaltyCore);
    const historyPoints = isInEditor ? historyItemsAuthoring : storeHistoryPoints;
    const labels = { points: pointsLabel, event: eventLabel, balance: balanceLabel, date: dateLabel };
    if (historyPoints.statusCode === 403 && !isInEditor) {
        redirectToAuthPage(config);
    }
    const eventMessages = {
        defaultPointsAddedMessage,
        defaultPointsSpentMessage,
        pointsRefundMessage,
        pointsRedemptionMessage,
        pointsCouponRedemptionMessage,
        pointsOrderAddedMessage,
        pointsCancellationMessage,
        pointsExpirationMessage,
        externalCouponLinkLabel,
    };
    const dispatchGTMEvent = (e) => {
        const clickedElement = e.target;
        const ctaName = clickedElement.textContent;
        dispatchTrackingEvent(TrackingEvents.TrackingPointsHistoryClick, {
            cta_name: ctaName || "pointsHistory",
        });
    };
    const handleShowMoreItems = () => {
        setPageNo(pageNo + 1);
    };
    const loadMoreLeft = useMemo(() => {
        const itemsLeft = historyPoints.total - historyPoints.items.length;
        return itemsLeft < loadAmount ? itemsLeft : loadAmount;
    }, [historyPoints.items.length, historyPoints.total, loadAmount]);
    useEffect(() => {
        dispatch(fetchPointsHistory({ perPage: loadAmount, pageNo: pageNo }));
    }, [pageNo, loadAmount, dispatch]);
    if (!isLogged && !isInEditor) {
        return null;
    }
    return (_jsxs("div", { className: classNames(styles.pointsHistory, {
            [styles.fullHistory]: isFullPointsHistory,
            [styles.noMargin]: removeMargin,
        }), children: [_jsx(ConditionalView, { condition: !isFullPointsHistory, children: _jsx("div", { className: styles.title, children: _jsx(Typography, { type: "small-title", color: "grey-3", children: title }) }) }), _jsx(HistoryTable, { rows: historyPoints.items, labels: labels, variant: "points", eventMessages: eventMessages }), historyPoints.isLoaded ? (_jsx(ConditionalView, { condition: loadMoreLeft !== 0 && isFullPointsHistory, children: _jsx(LoadMore, { className: styles.loadMore, label: __("loyalty.load.more.label"), onClick: handleShowMoreItems }) })) : (_jsx(Loading, {})), _jsx(ConditionalView, { condition: !isFullPointsHistory, children: _jsx("div", { className: styles.linkWrapper, children: _jsx(Button, { variant: "redirect", size: "large", color: "secondary", href: url, onClick: dispatchGTMEvent, children: text }) }) }), isFullPointsHistory && _jsx(ScrollToTop, {})] }));
};
//# sourceMappingURL=PointsHistory.js.map